module.exports = function ($state, ringCaptchaService) {
    return {
        restrict: 'E',
        template: require('./selfexclusion-confirm.html').trim(),
        link(scope) {
            ringCaptchaService.token = '';
            scope.redirectBack = function () {
                if (scope.redirectTo) {
                    $state.go(scope.redirectTo);
                }
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/selfexclusion-confirm-directive.js
 **/